export enum WishlistActionType {
  PDP = 'PDP',
  QuickView = 'QuickView',
  Tile = 'Tile',
}
